@let comparison = this.comparisonSg();
@let id = this.idSg();

<div
  class="comparison"
  (mouseenter)="setIconsVisibility(true)"
  (mouseleave)="setIconsVisibility(false)"
>
  <!-- Drag & drop handle -->
  <div class="comparison__drag-handle">
    <atn-ds-button
      [isIcon]="true"
      type="transparent"
    >
      <i class="atn-icon atn-drag"></i>
    </atn-ds-button>
  </div>

  <!-- Attribute dropdown -->
  <div class="comparison__attribute-container">
    <atn-ds-select-single
      [config]="{ overlay: { width: 'fit-content' } }"
      [items]="store.attributeItemsSg()"
      [value]="comparison.attributeId"
      (valueChange)="setAttributeId($event)"
    />
  </div>
  <!-- Operator dropdown -->
  <div class="comparison__operator-container">
    <atn-ds-select-single
      [items]="store.operatorItemsSg()"
      [value]="comparison.operator"
      (valueChange)="patchComparison({ operator: $event })"
    />
  </div>
  <!-- Value input -->
  <div class="comparison__value-container">
    @let valueType = this.attributeValueTypeSg();

    @if (valueType === Intrinsic.Boolean) {
      <atn-ds-checkbox
        [selected]="RawValue.cast(comparison.value, valueType) ?? false"
        (selectedChange)="patchComparison({ value: $event })"
      />
    } @else if (Intrinsic.ForNumber.isForNumber(valueType)) {
      <atn-ds-number
        [value]="RawValue.cast(comparison.value, valueType)"
        (change)="patchComparison({ value: $event ?? 0 })"
      />
    } @else {
      <atn-ds-text
        [value]="RawValue.cast(comparison.value, Intrinsic.Text)"
        (change)="patchComparison({ value: $event ?? '' })"
      />
    }
  </div>

  <!-- Icons -->
  <div
    class="comparison__icon-container"
    [class]="{
      'comparison__icon-container--hidden': !showIconsSg(),
    }"
  >
    <i
      class="atn-icon atn-trash atn-red"
      (click)="store.remove(id)"
    ></i>
    <i
      class="atn-icon atn-plus atn-blue"
      (click)="store.addSiblingTo(id)"
    ></i>
  </div>
</div>
